// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kb-article-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.kb-article-header h3 {
  margin: 4px 0 8px;
}

.kb-meta {
  display: flex;
  gap: 12px;
  align-items: center;
}

.kb-actions {
  display: flex;
  gap: 8px;
}

.kb-article-body {
  line-height: 1.7;
}

.kb-article-body h1,
.kb-article-body h2,
.kb-article-body h3 {
  margin-top: 24px;
  margin-bottom: 12px;
}

.kb-article-body table {
  width: 100%;
  border-collapse: collapse;
  margin: 16px 0;
}

.kb-article-body th,
.kb-article-body td {
  border: 1px solid #ddd;
  padding: 8px 12px;
  text-align: left;
}

.kb-article-body th {
  background: #f5f5f5;
  font-weight: 600;
}

.kb-article-body ul,
.kb-article-body ol {
  padding-left: 24px;
}

.kb-article-body code {
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.9em;
}
`, "",{"version":3,"sources":["webpack://./src/app/knowledge-base-module/components/kb-article-view/kb-article-view.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".kb-article-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.kb-article-header h3 {\n  margin: 4px 0 8px;\n}\n\n.kb-meta {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.kb-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.kb-article-body {\n  line-height: 1.7;\n}\n\n.kb-article-body h1,\n.kb-article-body h2,\n.kb-article-body h3 {\n  margin-top: 24px;\n  margin-bottom: 12px;\n}\n\n.kb-article-body table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 16px 0;\n}\n\n.kb-article-body th,\n.kb-article-body td {\n  border: 1px solid #ddd;\n  padding: 8px 12px;\n  text-align: left;\n}\n\n.kb-article-body th {\n  background: #f5f5f5;\n  font-weight: 600;\n}\n\n.kb-article-body ul,\n.kb-article-body ol {\n  padding-left: 24px;\n}\n\n.kb-article-body code {\n  background: #f5f5f5;\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: 0.9em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
